export default "__VITE_ASSET__eDH_aWV___"